// Makes the "Add another book" upsell forms add instantly: posts to /cart/add.js, refreshes the cart drawer, cart page
// and cart count in place, and opens the drawer. If anything fails, the normal form submit runs as a fallback.
const FORM_SELECTOR = 'form[data-upsell-form]';

async function refreshCarts() {
  await customElements.whenDefined('s-cart');
  const CartElement = customElements.get('s-cart');
  if (CartElement?.refreshMountedCarts) await CartElement.refreshMountedCarts();
}

function openDrawer() {
  if (window.location.pathname.endsWith('/cart')) return;
  const dialog = document.getElementById('cart-drawer');
  if (!(dialog instanceof HTMLDialogElement)) return;
  if (!dialog.open) dialog.showModal();
  dialog.dispatchEvent(new CustomEvent('s-cart:opened', { bubbles: true, detail: { dialogId: dialog.id } }));
}

// Cart remove links: remove the line in the background by its key and refresh the cart in place, so removing a book
// never leaves the page. The link's own address stays as a fallback when JavaScript cannot finish.
document.addEventListener('click', async (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[data-cart-remove]') : null;
  if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey) return;
  const key = link.dataset.lineKey;
  if (!key) return;
  event.preventDefault();
  if (link.getAttribute('aria-busy') === 'true') return;
  link.setAttribute('aria-busy', 'true');
  link.style.opacity = '0.4';
  // Hide the row straight away so removing feels instant; the cart refresh below brings totals in line.
  const row = link.closest('[data-cart-line]');
  if (row) {
    row.style.transition = 'opacity 0.15s ease';
    row.style.opacity = '0';
    setTimeout(() => { row.hidden = true; }, 150);
  }

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    if (!response.ok) throw new Error(`cart change failed: ${response.status}`);
    try {
      await refreshCarts();
    } catch {
      window.location.reload();
    }
  } catch {
    window.location.reload();
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches(FORM_SELECTOR)) return;
  if (form.dataset.busy === 'true') {
    event.preventDefault();
    return;
  }
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const label = button?.innerHTML;
  form.dataset.busy = 'true';
  if (button) {
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = button.dataset.addingLabel || '…';
  }

  try {
    const root = window.Shopify?.routes?.root || '/';
    const body = new FormData(form);
    body.delete('return_to');
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
    });
    if (!response.ok) throw new Error(`cart add failed: ${response.status}`);
    // Open the drawer as soon as the book is in the cart; its contents update when the refresh lands.
    openDrawer();
    try {
      await refreshCarts();
    } catch {
      if (window.location.pathname.endsWith('/cart')) window.location.reload();
    }
  } catch {
    // Fall back to the classic form post, which adds the book and opens the cart page.
    delete form.dataset.busy;
    form.submit();
    return;
  } finally {
    if (button && form.dataset.busy === 'true') {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      button.innerHTML = label;
    }
    delete form.dataset.busy;
  }
});
